import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';
import { categories as catList } from '@/mocks/data';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
              精选文章
            </h2>
            <p className="text-foreground-500 text-base">
              深入了解饭岛爱的故事与思想
            </p>
          </div>
          <Link
            to="/category/life-experience"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article) => {
            const cat = catList.find((c) => c.slug === article.category);
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-background-300 transition-all cursor-pointer group"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-3 flex-wrap">
                    {cat && (
                      <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-label">
                        {cat.name}
                      </span>
                    )}
                    <span className="text-xs text-foreground-400">{article.date}</span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}